import React from 'react';
import { Box, Stack, Paper, Typography } from '@mui/material';

const StatusCard = ({ title, value, color, sideIconColor, bordercolor }) => {
    return (
        <Paper elevation={0} sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: 342, height: 44, borderRadius: "12px", bgcolor: color, boxShadow: 'none', border: `1px solid ${bordercolor}`, overflow: 'hidden', }}>
            <Box sx={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', width: 5, height: 28, borderRadius: "0 12px 12px 0", bgcolor: sideIconColor, }}/>

            <Box sx={{display: "flex", justifyContent: "space-between", width: "100%", padding: "0 20px 0 14px", alignItems: "center" }}>
                <Typography variant="body2" sx={{ color: '#1D1D1D', fontWeight: 500, fontSize: "16px", }}>{title}</Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 500, color: "#1D1D1D", fontSize: "16px", }}>{value}</Typography>
            </Box>
        </Paper>
    );
};

export default function StatusCardsExample({totalStamps, usedStamps, leftStamps}) {
    return (
        <Stack direction="row" spacing={2} sx={{ padding: "15px 21px", bgcolor: 'transparent', justifyContent: 'space-between' }}>
            <StatusCard title="Total no. of Stamps" value={totalStamps} color="#F3F8FF" sideIconColor="#408EF6" bordercolor="#B4D2FA" />
            <StatusCard title="Number of Stamps used" value={usedStamps} color="#FFF3F3" sideIconColor="#FF4747" bordercolor="#FFCECE" />
            <StatusCard title="Number of Stamps left" value={leftStamps} color="#EEFFEF" sideIconColor="#4ED752" bordercolor="#A2FCA5" />
        </Stack>
    );
}